export default __webpack_public_path__ + "static/world-map-68e57539ce68bcc0d6e603122b32f910.svg";